// Statistics Knowledge Graph Samples
// Organized by difficulty levels with systematic naming

import { statisticsSamplesPart1 } from './statisticsSamples_part1.js';
import { statisticsSamplesPart2 } from './statisticsSamples_part2.js';

export const statisticsSamples = {
  fundamental: statisticsSamplesPart1.fundamental,
  intermediate: statisticsSamplesPart1.intermediate,
  harder: statisticsSamplesPart2.harder
}; 